<template>
    <component :is="tag">
        <component :is="controlTag" @mouseenter="onHover(true)" @mouseleave="onHover(false)" @click="onClick($event)">
            <slot name="icon"></slot>
        </component>

        <div @mouseleave="onBodyTextLeave(false)" v-if="showContent" class="tooltip-content-box shadow-sm">
            <slot name="text"></slot>
        </div>
    </component>
</template>

<script>
export default {
    props: {
        tag: {
            type: String,
            required: false,
            default() {
                return 'div';
            },
        },
        mobileControlUpToPx: {
            type: Number,
            required: false,
            default() {
                return 991;
            },
        },
        controlTag: {
            type: String,
            required: false,
            default() {
                return 'span';
            },
        },
        onlyClick: {
            type: Boolean,
            required: false,
            default() {
                return false;
            },
        },
    },

    data() {
        return {
            showContent: false,
        };
    },

    methods: {
        /**
         * Determine if the mobile control version should be used for the tooltip.
         *
         * @returns {boolean}
         */
        useMobileControl() {
            return window.innerWidth <= this.mobileControlUpToPx;
        },

        /**
         * Handles the event callback of hovering the control element.
         *
         * @param {boolean} status
         *
         * @returns {void}
         */
        onHover(status) {
            if (this.useMobileControl() || this.onlyClick) {
                return;
            }

            this.showContent = status;
        },

        /**
         * @param status
         */
        onBodyTextLeave(status) {
            if (this.useMobileControl()) {
                return;
            }

            this.showContent = status;
        },

        /**
         * Handles the event callback of clicking the control element.
         *
         * @param {PointerEvent} event
         *
         * @returns {void}
         */
        onClick(event) {
            event.preventDefault();
            this.showContent = !this.showContent;
        },
    },
};
</script>
